import React, { useEffect, useState } from "react";
import {
    PDFViewer,
    Document,
    Page,
    Text,
    View,
    Image,
    StyleSheet
} from "@react-pdf/renderer";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { useStore } from "../../shared/hooks/stateStore";
import { routeConfig } from "../../shared/common/constant";
import { convertNumTOWords } from "../../shared/hooks/wordNumb";
import { Skeleton } from "antd";
import signature from '../../assets/AuthorizedSignature.png'
import header from '../../assets/header.png';
import { fixedDecimal, roundOffDigits } from "../../shared/hooks/utils";

const BORDER_COLOR = '#5E5E5E'
const KEY_FONT_COLOR = '#5E5E5E'
const TABLE_HEADER_COLOR = '#D5D5D5'
const WHITE = '#FFFFFF'
const BLACK = '#000000'
const BORDER_STYLE = 'solid'
const BORDER_WIDTH = 1.3
const styles = StyleSheet.create({
    body: {
        paddingLeft: 7,
        paddingRight: 7,
        paddingTop: 7
    },
    table: {
        display: "table",
        width: "auto",
        borderStyle: BORDER_STYLE,
        borderColor: BORDER_COLOR,
        borderWidth: BORDER_WIDTH,
        borderRightWidth: 0,
        borderBottomWidth: 0
    },
    tableRow: {
        margin: "auto",
        flexDirection: "row"
    },
    tableRowHeight60: {
        margin: "auto",
        flexDirection: "row",
        height: 60
    },
    tableCol: {
        borderStyle: BORDER_STYLE,
        borderColor: BORDER_COLOR,
        borderBottomColor: BORDER_COLOR,
        borderWidth: BORDER_WIDTH,
        borderLeftWidth: 0,
        borderTopWidth: 0,
        padding: 1
    },
    tableColNoRight: {
        borderStyle: BORDER_STYLE,
        borderColor: BORDER_COLOR,
        // borderBottomColor: BORDER_COLOR,
        borderWidth: BORDER_WIDTH,
        borderRightWidth: 0,
        borderLeftWidth: 0,
        borderTopWidth: 0,
        padding: 2
    },
    tableColNoBottom: {
        borderStyle: BORDER_STYLE,
        borderColor: BORDER_COLOR,
        // borderBottomColor: BORDER_COLOR,
        borderWidth: BORDER_WIDTH,
        borderBottomWidth: 0,
        borderLeftWidth: 0,
        borderTopWidth: 0,
        padding: 2
    },
    tableColNoBorder: {
        borderRightWidth: 0,
        borderBottomWidth: 0,
        borderLeftWidth: 0,
        borderTopWidth: 0,
        padding: 2
    },
    tableColNoPadding: {
        borderStyle: BORDER_STYLE,
        borderColor: BORDER_COLOR,
        borderBottomColor: BORDER_COLOR,
        borderWidth: BORDER_WIDTH,
        borderLeftWidth: 0,
        borderTopWidth: 0,
        paddingTop: 1
    },
    tableCellHeader: {
        margin: "auto",
        //   margin: 5, 
        fontSize: 12,
        fontWeight: 500
    },
    tableCell: {
        // margin: "auto",
        // marginLeft: 5,
        fontSize: 9,
        fontWeight: "black"
    },
    tableCellSmall: {
        // margin: "auto",
        //   margin: 5, 
        fontSize: 8
    },
    height10: {
        height: 10
    },
    height20: {
        height: 20
    },
    height235: {
        height: 23.5
    },
    height255: {
        height: 25.5
    },
    height25: {
        height: 25
    },
    height27: {
        height: 27
    },
    height30: {
        height: 30
    },
    height35: {
        height: 35
    },
    height38: {
        height: 38
    },
    height40: {
        height: 40
    },
    height60: {
        height: 60
    },
    height80: {
        height: 80
    },
    height90: {
        height: 90
    },
    width5: {
        width: "5%"
    },
    width6: {
        width: "6%"
    },
    width7: {
        width: "7%"
    },
    width8: {
        width: "8%"
    },
    width9: {
        width: "9%"
    },
    width10: {
        width: "10%"
    },
    width125: {
        width: "12.5%"
    },
    width13: {
        width: "13%"
    },
    width15: {
        width: "15%"
    },
    width22: {
        width: "22%"
    },
    width25: {
        width: "25%"
    },
    width255: {
        width: "25.5%"
    },
    width40: {
        width: "40%"
    },
    width43: {
        width: "43%"
    },
    width50: {
        width: "50%"
    },
    width52: {
        width: "52%"
    },
    width625: {
        width: "62.5%"
    },
    width75: {
        width: "75%"
    },
    width85: {
        width: "85%"
    },
    width875: {
        width: "87.5%"
    },
    width100: {
        width: "100%",
    },
    footerPadding: {
        paddingTop: 12,
        paddingBottom: 5,
        letterSpacing: 4,
        color: KEY_FONT_COLOR
    },
    padding2: {
        padding: 2
    },
    padding4: {
        padding: 4
    },
    paddingTop7: {
        paddingTop: 7
    },
    marginBottom4: {
        marginBottom: 4
    },
    marginBottom8: {
        marginBottom: 8
    },
    marginTopBtm5: {
        marginBottom: 5,
        marginTop: 5
    },
    marginTop3: {
        marginTop: 3
    },
    marginTop5: {
        marginTop: 5
    },
    marginTop8: {
        marginTop: 8
    },
    marginTop10: {
        marginTop: 10
    },
    marginTop30: {
        marginTop: 30
    },
    fontSize8: {
        fontSize: 8
    },
    fontSize10: {
        fontSize: 10
    },
    fontSize12: {
        fontSize: 12
    },
    textCenter: {
        textAlign: "center"
    },
    textRight: {
        textAlign: "right"
    },
    textLeft: {
        textAlign: "left"
    },
    backgroundText: {
        backgroundColor: '#EBEBEB',
        padding: 5,
        borderRadius: 3
    },
    tableHeader: {
        backgroundColor: TABLE_HEADER_COLOR
    },
    tableCellKey: {
        color: KEY_FONT_COLOR
    },
    backgroundBlack: {
        backgroundColor: BLACK,
        color: WHITE,
    },
    tableColZeroPadding: {
        borderStyle: BORDER_STYLE,
        borderColor: BORDER_COLOR,
        borderBottomColor: BORDER_COLOR,
        borderWidth: BORDER_WIDTH,
        borderLeftWidth: 0,
        borderTopWidth: 0,
        padding: 0
    },
    margin3: {
        marginTop: 3,
        marginBottom: 3
    },
    image: {
        height: '13%',
        width: '100%',
        backgroundColor: '#ffffff'
    },
    signatureImage: {
        height: '200%',
        width: '100%'
    }
});

let purchaseOrderStoreData;
const PurchaseOrderPdf = () => {
    let { purchaseOrderInvoiceId } = useParams<any>();
    const [loading, setLoading] = useState<boolean>(true);
    const history = useHistory();
    const location = useLocation();

    useEffect(() => {
        purchaseOrderStoreData = useStore.getState().purchaseOrder;
        if (location.pathname.split('/').length === 3) {
            // || purchaseOrderStoreData['_id']
            if (!purchaseOrderStoreData) {
                history.push(routeConfig.purchaseOrderList.path)
            } else {
                fetch('https://openexchangerates.org/api/currencies.json')
                    .then(response => response.json())
                    .then(data => Object.entries(data).forEach(([key, value]) => {
                        if (key === purchaseOrderStoreData.currency) {
                            purchaseOrderStoreData.currencyvalue = value;

                            purchaseOrderInvoiceId = purchaseOrderStoreData['_id']
                            const gstBracket = JSON.parse(purchaseOrderStoreData.gstBracket);
                            purchaseOrderStoreData.taxType = +gstBracket.taxType;
                            purchaseOrderStoreData.taxFirst = +gstBracket.taxFirst
                            purchaseOrderStoreData.taxSecond = +gstBracket.taxSecond
                            purchaseOrderStoreData.amountSGST = roundOffDigits((purchaseOrderStoreData.taxFirst / 100) * purchaseOrderStoreData.amountTotalInInr);
                            purchaseOrderStoreData.amountCGST = roundOffDigits((purchaseOrderStoreData.taxSecond / 100) * purchaseOrderStoreData.amountTotalInInr);
                            purchaseOrderStoreData.amountInWords = convertNumTOWords(purchaseOrderStoreData.grandTotal, purchaseOrderStoreData.currency);

                            const grandTotalRf = roundOffDigits((((purchaseOrderStoreData.taxFirst + purchaseOrderStoreData.taxSecond) / 100) * purchaseOrderStoreData.amountTotalInInr) + purchaseOrderStoreData.amountTotalInInr);
                            purchaseOrderStoreData.roundOff = roundOffDigits(purchaseOrderStoreData.grandTotal - grandTotalRf);
                            setLoading(false);
                        }
                    }))

            }
        }
    }, []);
    return (
        <>
            {
                loading ? <Skeleton active /> :
                    <PDFViewer style={{ height: '100%', width: '100%' }} >
                        <MyDocument purchaseOrderStoreData={purchaseOrderStoreData} />
                    </PDFViewer>
            }
        </>
    );
}

export default PurchaseOrderPdf

const MyDocument = ({ purchaseOrderStoreData }) => (
    <Document title="Purchase Order" >
        <Page size="A4">
            <Image src={header} style={[styles.image]} />
            <View style={[styles.backgroundBlack, styles.marginTop5, styles.padding4, styles.marginBottom4]}>
                <Text style={[styles.fontSize12, , styles.textCenter]}>PURCHASE ORDER</Text>
            </View>
            <View style={styles.body}>
                <View style={[styles.table]}>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, styles.width25]}>
                            <Text style={[styles.tableCell, styles.fontSize8, styles.tableCellKey]}>PO No.</Text>
                        </View>
                        <View style={[styles.tableCol, styles.width25]}>
                            <Text style={[styles.tableCell]}>{purchaseOrderStoreData.poNumber}</Text>
                        </View>
                        <View style={[styles.tableCol, styles.width25]}>
                            <Text style={[styles.tableCell, styles.fontSize8, styles.tableCellKey]}>PO Date</Text>
                        </View>
                        <View style={[styles.tableCol, styles.width25]}>
                            <Text style={[styles.tableCell]}>{purchaseOrderStoreData.poDate}</Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, styles.width50, styles.height90]}>
                            <Text style={[styles.tableCell, styles.tableCellKey]}>To</Text>
                            <Text style={styles.tableCell}>{purchaseOrderStoreData.businessPartnerId.name}</Text>
                            <Text style={styles.tableCellSmall}>{purchaseOrderStoreData.businessPartnerId.address} </Text>
                        </View>
                        <View style={[styles.tableCol, styles.width50, styles.height90]}>
                                <Text style={[styles.tableCell, styles.tableCellKey]}>Ship To</Text>
                                <Text style={styles.tableCell}>{purchaseOrderStoreData.shipTo.name}</Text>
                                <Text style={styles.tableCellSmall}>{purchaseOrderStoreData.shipTo.address} </Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        {/* <View style={[styles.tableCol, styles.width15]}>
                            <Text style={[styles.tableCell, styles.fontSize8, styles.tableCellKey]}>PO Date</Text>
                            <Text style={styles.tableCell}>{purchaseOrderStoreData.poDate} </Text>
                        </View> */}
                        <View style={[styles.tableCol, styles.width50]}>
                            <Text style={[styles.tableCell, styles.fontSize8, styles.tableCellKey]}>Payment Terms</Text>
                            <Text style={styles.tableCell}>{purchaseOrderStoreData.paymentTerms.paymentTerm} </Text>
                        </View>

                        <View style={[styles.tableCol, styles.width25]}>
                            <Text style={[styles.tableCell, styles.fontSize8, styles.tableCellKey]}>FOB/FOR Point</Text>
                            <Text style={styles.tableCell}>{purchaseOrderStoreData.fobPoint} </Text>
                        </View>
                        <View style={[styles.tableCol, styles.width25]}>
                            <Text style={[styles.tableCell, styles.fontSize8, styles.tableCellKey]}>Delivery Terms</Text>
                            <Text style={styles.tableCell}>{purchaseOrderStoreData.deliveryTerms.deliveryTerm} </Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, styles.width50]}>
                            <Text style={[styles.tableCell, styles.fontSize8, styles.tableCellKey]}>Shipped Via</Text>
                            <Text style={styles.tableCell}>{purchaseOrderStoreData.shippedVia.shippingMode} </Text>
                        </View>
                        <View style={[styles.tableCol, styles.width50]}>
                            <Text style={[styles.tableCell, styles.fontSize8, styles.tableCellKey]}>Currency</Text>
                            <Text style={styles.tableCell}>{purchaseOrderStoreData.currencyvalue} </Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, styles.width15, styles.textCenter, styles.tableHeader]}>
                            <Text style={[styles.tableCell, styles.fontSize8, styles.tableCellKey, styles.margin3]}>Qty in MT</Text>
                        </View>
                        <View style={[styles.tableCol, styles.width22, styles.textCenter, styles.tableHeader]}>
                            <Text style={[styles.tableCell, styles.fontSize8, styles.tableCellKey, styles.margin3]}>Description of Goods </Text>
                        </View>
                        <View style={[styles.tableCol, styles.width255, styles.textCenter, styles.tableHeader]}>
                            <Text style={[styles.tableCell, styles.fontSize8, styles.tableCellKey, styles.margin3]}>Packing Type</Text>
                        </View>
                        <View style={[styles.tableCol, styles.width125, styles.textCenter, styles.tableHeader]}>
                            <Text style={[styles.tableCell, styles.fontSize8, styles.tableCellKey, styles.margin3]}>Unit Quantity</Text>
                        </View>
                        {/* <View style={[styles.tableCol, styles.width125, styles.textCenter, styles.tableHeader]}>
                            <Text style={[styles.tableCell, styles.fontSize8, styles.tableCellKey, styles.margin3]}>Unit Type</Text>
                        </View> */}
                        <View style={[styles.tableCol, styles.width125, styles.textCenter, styles.tableHeader]}>
                            <Text style={[styles.tableCell, styles.fontSize8, styles.tableCellKey, styles.margin3]}>Price in {purchaseOrderStoreData.currency}</Text>
                        </View>
                        <View style={[styles.tableCol, styles.width125, styles.textCenter, styles.tableHeader]}>
                            <Text style={[styles.tableCell, styles.fontSize8, styles.tableCellKey, styles.margin3]}>Amount</Text>
                        </View>
                    </View>
                    {
                        purchaseOrderStoreData.purchaseOrderItemDetails?.map((r, i) => {
                            return (
                                <View style={styles.tableRow} key={i}>
                                    <View style={[styles.tableCol, styles.width15, styles.textRight]}>
                                        <Text style={styles.tableCell}>{fixedDecimal(r.quantityInMt)}</Text>
                                    </View>
                                    <View style={[styles.tableCol, styles.width22]}>
                                        <Text style={styles.tableCell}>{r.descriptionOfGoods.productName}</Text>
                                    </View>
                                    <View style={[styles.tableCol, styles.width255, styles.textLeft]}>
                                        <Text style={styles.tableCell}>{r.packingTypes.packingType}</Text>
                                    </View>
                                    <View style={[styles.tableCol, styles.width125, styles.textRight]}>
                                        <Text style={styles.tableCell}>{fixedDecimal(r.unitQuantity)}</Text>
                                    </View>
                                    {/* <View style={[styles.tableCol, styles.width125, styles.textRight]}>
                                        <Text style={styles.tableCell}>{r.unitType}</Text>
                                    </View> */}
                                    <View style={[styles.tableCol, styles.width125, styles.textRight]}>
                                        <Text style={styles.tableCell}>{fixedDecimal(r.priceInInr)}</Text>
                                    </View>
                                    <View style={[styles.tableCol, styles.width125, styles.textRight]}>
                                        <Text style={styles.tableCell}>{fixedDecimal(r.amount)}</Text>
                                    </View>
                                </View>
                            )
                        })
                    }
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, styles.width625, styles.textRight]}>
                            <Text style={[styles.tableCell, styles.fontSize8, styles.tableCellKey]}>Consignment Total Quantity</Text>
                        </View>
                        <View style={[styles.tableCol, styles.width125, styles.textRight]}>
                            <Text style={styles.tableCell}>{fixedDecimal(purchaseOrderStoreData.consignmentTotalQuantity)}</Text>
                        </View>
                        <View style={[styles.tableCol, styles.width125, styles.textRight]}>
                            <Text style={[styles.tableCell, styles.fontSize8, styles.tableCellKey]}>Amount Total</Text>
                        </View>
                        <View style={[styles.tableCol, styles.width125, styles.textRight]}>
                            <Text style={styles.tableCell}>{fixedDecimal(purchaseOrderStoreData.amountTotalInInr)}</Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, styles.width875, styles.textRight]}>
                            <Text style={[styles.tableCell, styles.fontSize8, styles.tableCellKey]}>{purchaseOrderStoreData.gstNotification} {purchaseOrderStoreData.taxType === 1 ? 'SGST' : purchaseOrderStoreData.taxType === 2 ? ' IGST' : ''} {purchaseOrderStoreData.taxFirst}%</Text>
                        </View>
                        <View style={[styles.tableCol, styles.width125, styles.textRight]}>
                            <Text style={styles.tableCell}>{fixedDecimal(purchaseOrderStoreData.amountSGST)}</Text>
                        </View>
                    </View>
                    {
                        purchaseOrderStoreData.taxType === 1 && (<View style={styles.tableRow}>
                            <View style={[styles.tableCol, styles.width875, styles.textRight]}>
                                <Text style={[styles.tableCell, styles.fontSize8, styles.tableCellKey]}>{purchaseOrderStoreData.gstNotification} CGST {purchaseOrderStoreData.taxSecond}%</Text>
                            </View>
                            <View style={[styles.tableCol, styles.width125, styles.textRight]}>
                                <Text style={styles.tableCell}>{fixedDecimal(purchaseOrderStoreData.amountCGST)}</Text>
                            </View>
                        </View>)
                    }
                    
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, styles.width875, styles.textRight]}>
                            <Text style={[styles.tableCell, styles.fontSize8, styles.tableCellKey]}>ROUND OFF {purchaseOrderStoreData.currency}</Text>
                        </View>
                        <View style={[styles.tableCol, styles.width125, styles.textRight]}>
                            <Text style={styles.tableCell}>{fixedDecimal(purchaseOrderStoreData.roundOff)}</Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, styles.width875, styles.textRight]}>
                            <Text style={[styles.tableCell, styles.fontSize8, styles.tableCellKey]}>GRAND TOTAL in {purchaseOrderStoreData.currency}</Text>
                        </View>
                        <View style={[styles.tableCol, styles.width125, styles.textRight]}>
                            <Text style={styles.tableCell}>{fixedDecimal(purchaseOrderStoreData.grandTotal)}</Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, styles.width15, styles.textRight]}>
                            <Text style={[styles.tableCell, styles.fontSize8, styles.tableCellKey]}>Amount in Words</Text>
                        </View>
                        <View style={[styles.tableCol, styles.width85]}>
                            <Text style={styles.tableCell}>{purchaseOrderStoreData.amountInWords}</Text>
                        </View>
                    </View>
                    <View style={[styles.tableRow, styles.height38]}>
                        <View style={[styles.tableCol, styles.width100]}>
                            <Text style={[styles.tableCell, styles.fontSize8, styles.tableCellKey]}>Term & Condition</Text>
                            <Text style={[styles.tableCellSmall, styles.marginTop5]}>
                                <Text style={[styles.tableCellSmall, styles.marginTop5]}> 1. Please send two copies of your invoice to above mentioned address </Text>
                                <Text style={[styles.tableCellSmall, styles.marginTop5]}> 2. Enter this order in accordance with the prices, terms, delivery method and specification listed above.</Text>
                                <Text style={[styles.tableCellSmall, styles.marginTop5]}> 3. Plesae specify us immediately if you are unable to ship as specify</Text>
                            </Text>
                        </View>
                    </View>
                    <View style={[styles.tableRow, styles.height60]}>
                        <View style={[styles.tableCol, styles.width75]}>
                            <Text style={[styles.tableCell, styles.fontSize8, styles.tableCellKey]}>Additional Terms & Conditions</Text>
                            <Text style={styles.tableCell}>{purchaseOrderStoreData.additionalTermsAndConditions}</Text>
                        </View>
                        <View style={[styles.tableColNoPadding, styles.width25]}>
                            <View style={[styles.tableRow, styles.height235]}>
                                <View style={[styles.tableColNoBorder, styles.width100, styles.textRight]}>
                                    <Text style={[styles.tableCell]}>For, Chemtrade</Text>
                                </View>
                            </View>
                            <View style={[styles.tableRow, styles.height235]}>
                                <View style={[styles.tableColNoBorder, styles.width100, styles.textRight]}>
                                    <Image src={signature} style={[styles.signatureImage]} />
                                </View>
                            </View>
                            <View style={[styles.tableRow, styles.height235]}>
                                <View style={[styles.tableColNoBorder, styles.width100, styles.marginTop8, styles.textRight]}>
                                    <Text style={[styles.tableCell]}>Authorized Signature/Name</Text>
                                </View>
                            </View>
                        </View>
                    </View>
                </View>
            </View>
            {/* footer */}
            <View style={[styles.footerPadding, styles.marginBottom4]}>
                <Text style={[styles.fontSize10, styles.textCenter]}>
                Industrial Chemicals | APIs
                        </Text>
            </View>
            <View style={[styles.backgroundBlack, styles.padding4]}>
                <Text style={[styles.fontSize10, styles.textCenter]}>
                Plot No: 38, Kalathiya Corp. V-2, Diamond Nagar, Kholwad, Surat, Gujarat, India - 394180
                        </Text>
            </View>
        </Page>
    </Document >
);